// RiskNinja Frontend Application
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installFetchInterceptor } from './utils/fetchInterceptor';

// Configure PDF.js worker GLOBALLY at app startup to prevent version conflicts
import { pdfjs } from 'react-pdf';

// Install the global fetch interceptor before any code can issue a fetch.
installFetchInterceptor();

// FORCE PDF.js to use our local worker file with aggressive cache busting
const timestamp = Date.now();
const workerUrl = `/pdf.worker.min.js?v=${timestamp}&bustcache=${Math.random()}`;
pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;

console.log(`🚀 GLOBAL PDF.js worker configuration set at app startup`);
console.log(`🚀 PDF.js API version: ${pdfjs.version}`);
console.log(`🚀 Worker URL: ${workerUrl}`);
console.log(`🚀 This should eliminate version mismatches by forcing browser to fetch fresh worker`);

// Preload the worker to verify it exists
fetch(workerUrl, { method: 'HEAD' })
  .then(response => {
    if (response.ok) {
      console.log(`✅ Worker file verified and accessible`);
    } else {
      console.error(`❌ Worker file not found: ${response.status}`);
    }
  })
  .catch(error => {
    console.error(`❌ Worker file check failed:`, error);
  });

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Service worker registration. Required for installability + a basic offline
// shell. Only runs in production builds — dev would have cache-staleness pain.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .catch((err) => console.warn('Service worker registration failed:', err));
  });
}
